/**
 * Tier facts for public copy.
 *
 * Framing V4: tier limits come from `server/src/lib/tiers.ts` only. The
 * limits below are GENERATED from that file by `scripts/tier-sync.mjs`
 * (run at the start of `pnpm build`); the build fails if this file drifts.
 * Do not edit `TIER_LIMIT` by hand — change the server file and rebuild.
 *
 * The Pro price is not in the server file (it lives in the Stripe price
 * that `STRIPE_PRICE_ID` points at), so it is declared once here.
 */

import { TIER_LIMIT } from './tier.generated';

export { TIER_LIMIT };
export type { TierKey, TierLimit } from './tier.generated';

/** Monthly Pro price in Australian dollars, matching the live Stripe price. */
export const PRO_PRICE_AUD_MONTHLY = 20;
export const PRICE_CURRENCY = 'AUD';
